export default {
    methods: {
        $checkAuth() {
            console.log("checkAuth:" + this.$store.state.isLoggedIn);
            if (this.$store.state.isLoggedIn) return;
            this.$AJAX.checkUser().then(data => {
                setAuthRoutes(this, data);
            });
        },
        $logCredentials(creds) {
            console.log("logCredientials");
            if (this.$store.state.isLoggedIn) return;

            this.$AJAX.checkLoggin(creds).then(data => {
                //-- 100 is for logging, valid is for currentUser query at each route
                if (data.code === '100' || data.status === 'valid') 
                {
                    setAuthRoutes(this, data);
                    this.$router.push(this.$store.state.appRootPath);
                } 
                else 
                    this.$processDataMsg(data);
                
            });
        }
    }
}


function setAuthRoutes(Vue, data) {
    if (data.code === '100' || data.status === 'valid') 
    {
        Vue.$store.dispatch('login', data);
        //Vue.$router.push(Vue.$store.state.appRootPath);
        //-- Loading dyn-contents for the user
        //if (!Vue.$store.state.isDynContentLoaded)
            //Vue.$loadDynContent();    
    } 
    else 
    {
        Vue.$processDataMsg(data);
        return Vue.$router.push('/login');
    }
         
         
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js